
import React from 'react';
import VegetableBlockPrinting from 'views/VegetableBlockPrinting';

const vmPage = () => {
  return <VegetableBlockPrinting/>;
};

export default vmPage;